export default class CourseProvider {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "onlineTemplateIDs": [
      "string"
    ],
    "provider": {
      "APIEndpoint": "string",
      "APIID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      "APIKey": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      "APIPort": 0,
      "APIUserID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      "APIUserKey": "string",
      "APIOldUserIDs": [
        "string"
      ],
      "SSO": {
        "iCode": "string",
        "key": "string"
      },
      "learnerRole": "string",
      "orgID": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    },
    "type": "D2L"
  }
  */
  async createCourseProvider(providerObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/courseProvider/new`;
    req.body = providerObj;
    return await req.exec();
  }
  async updateCourseProvider(providerObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = `/courseProvider/${providerObj.id}`;
    req.body = providerObj;
    return await req.exec();
  }
  async deleteCourseProvider(providerID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/courseProvider/${providerID}`;
    return await req.exec();
  }
  async getCourseProvider(providerID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/courseProvider/${providerID}`;
    return await req.exec();
  }
  async getAllProviders() {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/courseProviders`;
    return await req.exec();
  }
}
